import React from "react";
import Annotation from "../../model/Annotation";
import { useNavigate } from "react-router";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import ImgUtil from "../../utils/ImgUtil";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import AppIcons from "../../utils/AppIcons";
import TimeUtil from "../../utils/TimeUtil";
import ButtonInfo from "../common/button/ButtonInfo";

interface IAnnotationsListElementProps {
  data: Annotation;
  canEdit: boolean;
}

function AnnotationsListElement({
  data,
  canEdit,
}: IAnnotationsListElementProps) {
  // reference to the navigator
  const navigate = useNavigate();

  return (
    <div
      className="details-grid-element"
      onClick={() => {
        navigate(
          SETTINGS.get_path({
            section: AppSections.ANNOTATIONS,
            id: data.id,
            subsection: AppSubSections.VIEW,
          })
        );
      }}
    >
      <div
        className="details-grid-icon"
        style={{
          backgroundImage: `url(${ImgUtil.display_icon(data.icon_path)})`,
        }}
      ></div>
      <div className="details-grid-content">
        <div className="details-grid-description">
          <div>
            <h3>{data.name}</h3>
            {canEdit && (
              <Button
                label="Edit"
                className="mr-0"
                purpose={ButtonAction.EDIT}
                type={ButtonType.ICON}
                onClick={() =>
                  navigate(
                    SETTINGS.get_path({
                      section: AppSections.ANNOTATIONS,
                      id: data.id,
                      subsection: AppSubSections.EDIT,
                    })
                  )
                }
              />
            )}
          </div>
          <p>{data.description}</p>
        </div>
        <div className="details-grid-statistics">
          <ButtonInfo>
            {AppIcons.CLOCK}
            created on: <span>{TimeUtil.display_date(data.created_on)}</span>
          </ButtonInfo>
          <ButtonInfo>
            {AppIcons.USER}
            created by: <span>{data.username}</span>
          </ButtonInfo>
          <ButtonInfo>
            {AppIcons.DETAIL_LEVEL}
            <span>{data.annotation_infos?.length}</span> attached files
          </ButtonInfo>
        </div>
      </div>
    </div>
  );
}

export default AnnotationsListElement;
